import React, { useEffect, useRef, useState } from "react";
import { Html, OrbitControls, useGLTF, useProgress } from "@react-three/drei";
import { Vector3 } from "three";
import { useFrame } from "@react-three/fiber";
import { roleConfig } from "../config";

interface demoObject {
  url: string;
  role: string;
  setIsLoaded: (value: boolean) => void;
}

export const Demo = ({ role, url, setIsLoaded }: demoObject) => {
  const { scene } = useGLTF(url);
  const demoRef = useRef<any>();
  const [direction] = useState(() => new Vector3(0, 0.6, 5));
  const { progress } = useProgress();

  const titleColor = roleConfig.find((x) => x.name === role)?.color || "";
  const OverlayItem = () => {
    return (
      <group rotation={[0, 20, 0]} position={[-8, 1, -8]}>
        <Html
          transform
          center
          className={`z-0 w-80 rounded-md overflow-hidden transition-opacity duration-1000`}
        >
          <div>
            <div className="bg-white bg-opacity-50 backdrop-blur-lg text-xs p-2 mx-8">
              <h2
                style={{ color: titleColor }}
                className={"font-bold text-3xl"}
              >
                {role?.toUpperCase()}
              </h2>
            </div>
            <div className="bg-white bg-opacity-50 backdrop-blur-lg text-xs p-2 mx-8 mt-2">
              <h3 className="text-ls text-justify">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum
              </h3>
            </div>
          </div>
        </Html>
      </group>
    );
  };

  useEffect(() => {
    if (progress === 100) {
      setIsLoaded(true); // 当进度达到 100% 时触发
    }
  }, [progress, setIsLoaded]);

  let isClockwise = Math.random() < 0.5;
  useFrame(() => {
    if (demoRef.current) {
      demoRef.current.position.add(direction.multiplyScalar(0.01));

      if (isClockwise) {
        demoRef.current.rotation.y += 0.01;
      } else {
        demoRef.current.rotation.y -= 0.01;
      }
    }
  });

  return (
    <>
      <ambientLight intensity={1} color={"#ffffff"} />
      <primitive
        ref={demoRef}
        object={scene}
        rotation={[0, 0, 0]}
        position={[0, -1.8, -1]}
        scale={4}
        castShadow
      />
      <OverlayItem />
      <directionalLight
        position={[10, 10, 15]} // 确保光源位于地球的外部
        intensity={2}
      ></directionalLight>
      <directionalLight
        position={[-10, 10, -15]} // 确保光源位于地球的外部
        intensity={2}
      ></directionalLight>
      <OrbitControls
        enablePan={false}
        enableZoom={false}
        enableRotate={false}
      />
    </>
  );
};
